<ms-split-header #splitHeaderComponent [enableScroll]="isInSheetView">
    <ng-container slot="header">
        @if (!event.isFinished() && periodTabs && periodTabs.length > 0) {
            <ds-tabs-group
                size="small"
                variant="horizontal"
                scrollable="true"
                [fullWidthTabs]="false"
                [activeTab]="activeId"
                (activeTabChange)="setPeriodTabSelected($event)">
                @for (tab of periodTabs; track $index) {
                    <ds-tab [name]="tab.id.toString()">
                        <ng-container *dsTabHeader>
                            <span>{{ tab.title }} </span>
                        </ng-container>
                    </ds-tab>
                }
                <ds-divider />
            </ds-tabs-group>
        }
    </ng-container>
    <ng-container slot="content">
        @switch (groupType) {
            @case ([groupTypes.Regular, groupTypes.USGroupedList].includes(groupType) ? groupType : !groupType) {
                <ms-regular-option-group
                    [event]="event"
                    [optionGroup]="activeGroup"
                    [groupType]="groupType"
                    [thresholds]="thresholds"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromotedOptionIdsMap]="crmPromoIdsMap.options"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [showPlayerStats]="showPlayerStats"
                    [optionsLimitOverride]="optionsLimitOverride"
                    (showAllRequested)="showAllRequested.next()" />
            }
            @case (groupTypes.CorrectScore) {
                <ms-correct-score-option-group-wrapper
                    [event]="event"
                    [optionGroup]="activeGroup"
                    [isShowMoreDisabled]="!thresholds && !optionsLimitOverride"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromotedOptionIdsMap]="crmPromoIdsMap.options"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride"
                    (showAllRequested)="showAllRequested.next()" />
            }
            @case (groupTypes.PlayerMilestone) {
                <ms-player-milestone-option-group
                    [event]="event"
                    [optionGroup]="activeGroup"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride"
                    [showPlayerStats]="showPlayerStats"
                    (showAllRequested)="showAllRequested.next()" />
            }
            @case (groupTypes.PlayerMilestoneOverUnder) {
                <ms-player-milestone-over-under-option-group
                    [event]="event"
                    [optionGroup]="activeGroup"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride"
                    [showPlayerStats]="showPlayerStats"
                    (showAllRequested)="showAllRequested.next()" />
            }
            @case (groupTypes.OverUnder) {
                <ms-over-under-option-group
                    [event]="event"
                    [optionGroup]="activeGroup"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride"
                    (showAllRequested)="showAllRequested.next()" />
            }
            @case (groupTypes.GoalScorer) {
                <ms-goal-scorer-option-group
                    [event]="event"
                    [optionGroup]="activeGroup"
                    [isShowMoreDisabled]="!thresholds && !optionsLimitOverride"
                    [trackingModuleType]="trackingModuleType"
                    [tracking]="tracking"
                    [showMarketHelp]="showMarketHelp"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride"
                    (showAllRequested)="showAllRequested.next()" />
            }
            @case (groupTypes.SixPack) {
                <ms-six-pack-option-group
                    [event]="event"
                    [optionGroup]="activeGroup"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [showLogoColor]="showSixPackLogosColor"
                    [showSixPackParticipantImages]="showSixPackLogos"
                    [showPlayerStats]="showPlayerStats" />
            }
            @case (groupTypes.PlayerProps) {
                <ms-player-props-option-group
                    [event]="event"
                    [optionGroup]="activeGroup"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride"
                    [showPlayerStats]="showPlayerStats"
                    (showAllRequested)="showAllRequested.next()" />
            }
            @case (groupTypes.Spread) {
                <ms-spread-option-group
                    [event]="event"
                    [optionGroup]="activeGroup"
                    [tracking]="tracking"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [trackingModuleType]="trackingModuleType"
                    [optionsLimitOverride]="optionsLimitOverride"
                    (showAllRequested)="showAllRequested.next()" />
            }
            @case (groupTypes.Scorecast) {
                <ms-scorecast-option-group
                    [event]="event"
                    [optionGroup]="activeGroup"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails" />
            }
            @case (groupTypes.Wincast) {
                <ms-wincast-option-group
                    [event]="event"
                    [optionGroup]="activeGroup"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails" />
            }
            @case ([groupTypes.RaceTo, groupTypes.BTTS].includes(groupType) ? groupType : !groupType) {
                <ms-score-market-option-group
                    [event]="event"
                    [optionGroup]="activeGroup"
                    [groupType]="groupType"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride"
                    (showAllRequested)="showAllRequested.next()" />
            }
            @case (groupTypes.YesNo) {
                <ms-yes-no-option-group
                    [event]="event"
                    [optionGroup]="activeGroup"
                    [tracking]="tracking"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride"
                    [trackingModuleType]="trackingModuleType"
                    (showAllRequested)="showAllRequested.next()" />
            }
            @case (groupTypes.TotalScore) {
                <ms-total-score-option-group
                    [event]="event"
                    [optionGroup]="activeGroup"
                    [tracking]="tracking"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [sourceOfPick]="sourceOfPick"
                    [trackingModuleType]="trackingModuleType"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride" />
            }
            @case (groupTypes.Head2Head) {
                <ms-head-to-head-option-group
                    [event]="event"
                    [optionGroup]="activeGroup"
                    [tracking]="tracking"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails" />
            }
            @case (groupTypes.BetBuilderStandard) {
                <ms-bet-builder-standard-group
                    [event]="event"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [optionGroup]="activeGroup"
                    [sourceOfPick]="sourceOfPick"
                    (showAllRequested)="showAllRequested.next()" />
            }
            @case (groupTypes.BetBuilderSixPack) {
                <ms-bet-builder-six-pack [event]="event" [optionGroup]="activeGroup" [sourceOfPick]="sourceOfPick" />
            }
            @case (groupTypes.BetBuilderOverUnder) {
                <ms-bet-builder-over-under-option-group
                    [event]="event"
                    [optionGroup]="activeGroup"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [sourceOfPick]="sourceOfPick"
                    (showAllRequested)="showAllRequested.next()" />
            }
            @case (groupTypes.BetBuilderCorrectScore) {
                <ms-bet-builder-correct-score-option-group
                    [event]="event"
                    [optionGroup]="activeGroup"
                    [isShowMoreDisabled]="!thresholds"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromotedOptionIdsMap]="crmPromoIdsMap.options"
                    [sourceOfPick]="sourceOfPick"
                    [optionsLimitOverride]="optionsLimitOverride"
                    (showAllRequested)="showAllRequested.next()" />
            }
            @case (groupTypes.BetBuilderSpread) {
                <ms-bet-builder-spread-option-group
                    [event]="event"
                    [optionGroup]="activeGroup"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [sourceOfPick]="sourceOfPick" />
            }
            @case (groupTypes.BetBuilderRaceTo) {
                <ms-bet-builder-teams-option-group
                    [event]="event"
                    [optionGroup]="activeGroup"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [sourceOfPick]="sourceOfPick" />
            }
            @case (groupTypes.BetBuilderGoalScorer) {
                <ms-bet-builder-goalscorer-option-group
                    [event]="event"
                    [optionGroup]="activeGroup"
                    [isShowMoreDisabled]="!thresholds"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [sourceOfPick]="sourceOfPick"
                    (showAllRequested)="showAllRequested.next()" />
            }
            @case (groupTypes.BetBuilderYesNo) {
                <ms-bet-builder-goalscorer-option-group
                    [event]="event"
                    [optionGroup]="activeGroup"
                    [isShowMoreDisabled]="!thresholds"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [sourceOfPick]="sourceOfPick"
                    (showAllRequested)="showAllRequested.next()" />
            }
            @case (groupTypes.BetBuilderPlayerProps) {
                <ms-bet-builder-goalscorer-option-group
                    [event]="event"
                    [optionGroup]="activeGroup"
                    [isShowMoreDisabled]="!thresholds"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [showMarketAttribute]="true"
                    [sourceOfPick]="sourceOfPick"
                    (showAllRequested)="showAllRequested.next()" />
            }
        }
    </ng-container>
</ms-split-header>
